import { Box, Skeleton, Stack, Typography } from "@mui/material";
import {
  LABEL_FONT_SIZE,
  STORY_CIRCLE_SIZE,
} from "Components/Stories/StoryAvatar";

const PLACEHOLDER_COUNT = 6;

const LABEL_WIDTHS = [44, 32, 52, 38, 48, 30];

/**
 * Loading placeholder for StoriesBar, dimension-matched to StoryAvatar so the bar swaps in with
 * zero layout shift: circle-wide columns (STORY_CIRCLE_SIZE) 16px apart, circle-sized skeletons
 * 8px above a real caption-variant Typography wrapping the text skeleton so the label line inherits
 * the exact caption line-height instead of the default body one.
 */
export const StoriesBarSkeleton = () => (
  <Box
    sx={{
      display: "flex",
      gap: 4,
      overflow: "hidden",
      py: 1,
      px: 0.5,
    }}
  >
    {Array.from({ length: PLACEHOLDER_COUNT }).map((_, index) => (
      <Stack
        key={`story-skeleton-${index}`}
        alignItems="center"
        gap={2}
        sx={{ width: STORY_CIRCLE_SIZE, flexShrink: 0 }}
      >
        <Skeleton
          variant="circular"
          width={STORY_CIRCLE_SIZE}
          height={STORY_CIRCLE_SIZE}
        />
        <Typography
          variant="caption"
          sx={{
            width: LABEL_WIDTHS[index % LABEL_WIDTHS.length],
            fontSize: LABEL_FONT_SIZE,
          }}
        >
          <Skeleton />
        </Typography>
      </Stack>
    ))}
  </Box>
);
